import styled from '@emotion/styled';
import { FaChrome, FaFacebook, FaLinkedin, FaPhoneAlt } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { SECONDARY } from '../../../../shared/colors';
// import { Wave } from '../../WaveSvg/waveSvg';

const FooterContainer = styled.div`
  margin-top: -1px;
  padding: 20px;
  background-color: ${SECONDARY};
  color: grey;
  min-height: 300px;
  padding-top: 50px;

  .content {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;

    > div {
      display: flex;
      flex-direction: column;
      margin: 20px;

      h3 {
        color: white;
        font-family: Montserrat;
      }

      p {
        font-size: 15px;
        font-family: Calibri;
        margin: 0;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }

      > .social-icon {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
      }
    }
  }

  .copyright {
    text-align: center;
    font-size: 14px;
  }
`;

export const Footer = () => {
  return (
    <>
      {/*    <Wave /> */}
      <FooterContainer id='contact'>
        <div className='content'>
          <div>
            <h3>Compte</h3>

            <p>Inscription</p>
            <p>Connexion</p>
            <p>Essai gratuit - Démo</p>
            <p>Télécharger MoranjEtrade</p>
          </div>

          <div>
            <h3>Support utilisateur</h3>

            <p>Mise à jour applicatif</p>
            <p>Documentation</p>
            <p>Guide d'utilisation</p>
            <p>FAQ</p>
            <p>Support </p>
          </div>

          <div>
            <h3>Autres</h3>

            <p>Mentions Légales</p>
            <p>Conditions générales d'utilisation</p>
            <p>Politique de confidentialité</p>
            <p>Aide & FAQs</p>
          </div>

          <div>
            <h3>Contactez-nous</h3>

            <div className=''>
              {socialLinks.map(({ name, link, icon }, i) => (
                <p key={i} style={{ marginBottom: 5 }}>
                  {icon}
                  {name}
                </p>
              ))}
            </div>
          </div>
        </div>

        <div className='copyright'>
          <hr style={{ backgroundColor: 'white' }} />
          <p style={{ textAlign: 'center' }}>Copyright © 2025.</p>
        </div>
      </FooterContainer>
    </>
  );
};

const socialLinks = [
  {
    name: 'Facebook',
    link: '/',
    icon: (
      <FaFacebook
        size={18}
        color='white'
        style={{ marginBottom: -5, marginRight: 10 }}
      />
    ),
  },
  {
    name: 'LinkedIn',
    link: '/',
    icon: (
      <FaLinkedin
        size={18}
        color='white'
        style={{ marginBottom: -5, marginRight: 10 }}
      />
    ),
  },
  {
    name: 'Téléphone',
    link: undefined,
    icon: (
      <FaPhoneAlt
        size={18}
        color='white'
        style={{ marginBottom: -5, marginRight: 10 }}
      />
    ),
  },
  {
    name: 'Site web',
    link: '/',
    icon: (
      <FaChrome
        size={18}
        color='white'
        style={{ marginBottom: -5, marginRight: 10 }}
      />
    ),
  },
  {
    name: 'Mail',
    link: undefined,
    icon: (
      <MdEmail
        size={18}
        color='white'
        style={{ marginBottom: -5, marginRight: 10 }}
      />
    ),
  },
];
